export default __webpack_public_path__ + "static/transaction-page-provider-668c686c02faaa68ca2de28c37fd0203.png";